import React, { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FAQ } from "../../components/FAQ/FAQ";
import { Headline } from "../../components/Headline/Headline";
import { Mail } from "../../components/Icons/Mail";
import { Help } from "../../components/Icons/Help";
import { Section } from "../../components/Section/Section";
import TopFAQ from "../../components/TopFAQ/TopFAQ";
import { SupportContext } from "../../contexts/SupportContext";
import { HTMLParser } from "../../components/HTMLParser/HTMLParser";

interface HelpPageProps {}

export const HelpPage: React.FC<HelpPageProps> = () => {
  const supportContext = useContext(SupportContext);
  const support = supportContext.supportItems[0];

  return (
    <div className="help-page page">
      <Section>
        <Container>
          <Row>
            <Col lg={{ span: 8, offset: 2 }}>
              <div className="hl">
                <Help />
                <h4 className="over">Hilfe &amp; Support</h4>
                <Headline level="h1" bold="Wir helfen Ihnen gerne" />
              </div>
              {support && (
                <div className="intro">
                  <HTMLParser html={support.text_hilfesupport} />
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col lg={{ span: 8, offset: 2 }}>
              <Headline level="h2" bold="Die häufigsten Fragen" />
              <TopFAQ />
            </Col>
          </Row>
        </Container>
      </Section>
      <Section background="lightblue">
        <Container>
          <Row>
            <Col lg={{ span: 8, offset: 2 }}>
              <Headline level="h2" bold="Themen" />
              <FAQ />
            </Col>
          </Row>
        </Container>
      </Section>
      <Section name="contact">
        <Container>
          <Row>
            <Col lg={{ span: 8, offset: 2 }}>
              <Headline level="h2" bold="Schreiben Sie uns eine E-Mail" />
              {support && (
                <div className="support-item">
                  <Mail />
                  <HTMLParser html={support.contact_support} />
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </Section>
    </div>
  );
};
